import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ModelButton from '../ModelButton';
import { VideoModel } from '../../../../types/store';

import s from './ModelSelector.scss';
import sControl from '../VideoCreatorControls.scss';

export interface Props {}

const ModelSelector: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      <label className={sControl['control-label']}>
        {t('studio.videoCreator.label.model')}
      </label>
      <div className={s['content']}>
        <ModelButton type={VideoModel.HAILUO} />
        <ModelButton type={VideoModel.VEO} />
        <ModelButton type={VideoModel.WAN} />
        <ModelButton type={VideoModel.SEEDANCE} />
      </div>
    </div>
  );
};

ModelSelector.displayName = 'ModelSelector';
export default ModelSelector;
